import Vue from "vue";
import axios from "axios";
import configuration from "@/utils/configuration";

const createCourseModules = {
  namespaced: true,

  state: {
    loading: {},
    error: {},
    packageList:null,
    optionList:null
  },
  getters: {
    getPackageList: (state) => state.packageList,
    getOptionList: (state) => state.optionList,
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
  },
  mutations: {

    SET_LOADING(state, { action, status }) {
      Vue.set(state.loading, action, status);
    },
    SET_ERROR(state, { action, message }) {
      Vue.set(state.error, action, message);
    },
    SET_PACKAGELIST(state,packageList){
      state.packageList = packageList
    },
    SET_OPTIONLIST(state,optionList){
      state.optionList = optionList
    },
    CLEAR_ALL_ERRORS(state) {
      state.error = {};
    },
    CLEAR_ERROR(state, action) {
        Vue.set(state.error, action, null);
      },
  },
  actions: {
    clearErrorMessage({ commit, state }, action) {
      if (state.error[action]) {
        commit('CLEAR_ERROR', action);
      } 
    },
    clearAllErrors({ commit }) {
      commit('CLEAR_ALL_ERRORS');
    },
    
    //  getPackageList 
    async getPackageList({ commit }) {
      const action = "getPackageList";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/packages`,
        });
        commit("SET_PACKAGELIST", data.data);
        return data.data
      } catch (error) {
        commit("SET_ERROR", {action,message:error.response?.data?.message ||error.message ||`${action} Failed`,});
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

     //  getOptionList 
     async getOptionList({ commit }) {
      const action = "getOptionList";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/options`,
        });
        commit("SET_OPTIONLIST", data.data);
        return data.data
      } catch (error) {
        commit("SET_ERROR", {action,message:error.response?.data?.message ||error.message ||`${action} Failed`,});
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
  },
};

export default createCourseModules;
